import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-error-state',
  templateUrl: './error-state.component.html',
  styleUrl: './error-state.component.scss',
  standalone: false
})
export class ErrorStateComponent {
  @Input() errorMessage: string;
  @Input() backLink: string = '/';
}
